import gsap from 'gsap';
let img1, img2;

class Tube {
    constructor() {
        this.pos = {
            x: width/2,
            y: height/2,
            opacity: 1
        }
        this.state = 'spinning';
        this.currentImage = 0;
        this.spinInt = setInterval(() => {
            this.currentImage++;
            if(this.currentImage >= this.images.length) {
                this.currentImage = 0;
            }
        }, 150);
        this.blownupImage = loadImage(`blownup.png`);
        this.images = [ loadImage(`Frame 1.png`),
                        loadImage(`Frame 2.png`),
                        loadImage(`Frame 3.png`),
                        loadImage(`Frame 4.png`),
                        loadImage(`Frame 5.png`),
                        loadImage(`Frame 6.png`),
                        loadImage(`Frame 7.png`),
                        loadImage(`Frame 8.png`)]
    }

    beginFade() {
        gsap.to(this.pos, {opacity: 0, duration: 2});
    }

    animateIn(onComplete) {
        var t1 = gsap.timeline();
        t1.to(this.pos, {y: height/50, duration: 1, ease:'circ.out'})
        t1.to(this.pos, {y:height/2 - 50, duration:1.5, ease:'circ.in', onComplete: () => {
            this.state = 'blownup';
            clearInterval(this.spinInt);
            setTimeout(() => onComplete(), 100);
        }});
    }

    draw() {
        let imageObj;
        if(this.state === 'spinning') {
            imageObj = this.images[this.currentImage];
        }
        else if(this.state === 'blownup') {
            imageObj = this.blownupImage;
        }
        tint(255, this.pos.opacity*255);
        image(imageObj, this.pos.x-50, this.pos.y, 100, 100);
    }

   
}

export default Tube;